import React from 'react'

const Pdf = () => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      {/* Document background */}
      <path 
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" 
        fill="#E53E3E" 
        stroke="#E53E3E" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      {/* Document corner fold */}
      <polyline 
        points="14,2 14,8 20,8" 
        fill="#C53030"
        stroke="#C53030" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      {/* PDF text */}
      <text 
        x="12" 
        y="16" 
        textAnchor="middle" 
        fontSize="6" 
        fontWeight="bold" 
        fill="white"
      >
        PDF
      </text>
    </svg>
  )
}

export default Pdf